<!-- 新增订货 -->
<template>
  <div>
    <!-- 新增订货信息 -->
    <el-dialog :visible.sync="isshow" width="30%" append-to-body>
      <div class="title">批量插入周六周日</div>
      <div class="flex-row">
        <span>开始时间：</span>
        <div class="this-el-input">
          <el-date-picker v-model="stime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"/>
        </div>
      </div>
      <div class="flex-row" style="margin-top: 15px;">
        <span>结束时间：</span>
        <div class="this-el-input">
          <el-date-picker v-model="etime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"/>
        </div>
        <el-button type="primary" style="margin-left: 30px;" @click="insert">插入</el-button>
      </div>
      <div class="comment">
        <p>1、此操作是为了便于设置全年的周六、周日；</p>
        <p>2、最好一次插入1年的周末，不要重复插入，导致数据重复；</p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        isshow: false, //显示弹框
        stime:'',
        etime:''
      }
    },
    methods: {
      show() {
        this.isshow = true;
      },
      //插入周六周日
      insert(){
        let curr = this;

        const loading = this.$loading({
          lock: true,
          text: '正在处理',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        axios({
          method: 'post',
          url: curr.appURL + '/renli.php',
          data: {
            token: localStorage.token,
            stime:curr.stime,
            etime:curr.etime,
            type: 'holidayBatchInsert'
          },
        })
        .then(res => {
          if (res.data.code == 0) {
             curr.$emit('reload');//通知刷新父页面
             this.$alert('操作成功！', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                loading.close();
              }
            });
          }
        });
      }
    },
    mounted() {
      let date1 = new Date();
      let year1 = date1.getFullYear();
      this.stime = year1 + '-' + '01' + '-' + '01';
      this.etime = year1 + '-' + '12' + '-' + '31';
    }
  };
</script>
<style scoped>
  .title{
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 35px;
    text-align: center;
  }
  .flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    box-sizing: border-box;
    padding-left: 50px;
  }

  .this-el-input {
    width: 200px;
    display: flex;
  }
  .comment{
    color: red;
    box-sizing: border-box;
    padding-left: 50px;
    margin-top: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/holiday-batch-insert.vue